import { render } from "./daysgroupsAdd.vue?vue&type=template&id=2046628a&scoped=true"
import script from "./daysgroupsAdd.vue?vue&type=script&lang=js"
export * from "./daysgroupsAdd.vue?vue&type=script&lang=js"

import "./daysgroupsAdd.vue?vue&type=style&index=0&id=2046628a&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2046628a"]])

export default __exports__